var pageView = (function (view) {

    view.initInputs = function () {
        inputService.initInputs();
        inputService.initKeyEvents();
        inputService.submitValidation();
    }
    view.initScrolling = function () {
        scrollService.initScrolling();
    }
    return view;

})(pageView || {});

document.addEventListener("DOMContentLoaded", function (event) {
    pageView.initInputs();
    pageView.initScrolling();
});
